import { render, staticRenderFns } from "./zzyPause.vue?vue&type=template&id=1f228da7&scoped=true"
import script from "./zzyPause.vue?vue&type=script&lang=js"
export * from "./zzyPause.vue?vue&type=script&lang=js"
import style0 from "./zzyPause.vue?vue&type=style&index=0&id=1f228da7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f228da7",
  null
  
)

export default component.exports